import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel } from '../../_base/crud';
import { LinkGroup } from '../_models/link-group.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class LinkGroupService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  createLinkGroup(body: any) {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<LinkGroup>(url, body, { headers });
  }

  private static getLinkGroupsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}&is_active=${filter.isActive}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.teams) fromString += `&teams_has=${filter.teams}`;
    }

    return fromString;
  }

  findLinkGroups(queryParams: QueryParamsModel): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups`;
    const params = new HttpParams({
      fromString: LinkGroupService.getLinkGroupsListQueryString(queryParams),
    });
    return this.http.get<any>(url, { params });
  }
  getMenuLinkGroups(): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(url, { headers });
  }
  loadLinkGroups(): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers });
  }

  updateLinkGroup(_linkGroup: LinkGroup): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups/${_linkGroup.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<LinkGroup>(url, _linkGroup, { headers });
  }

  deleteLinkGroup(linkGroupId: number): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link_groups/${linkGroupId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }
}
